<template>
  <div :class="{homeH5:$region !== 'jp'}">
    <div v-if="$region !== 'jp' ">
      <mswipe
        :bannerLists="bannerLists"
        v-if="bannerLists && bannerLists.length > 0"
      ></mswipe>
      <h5-nav v-if="$region !== 'jp' "></h5-nav>
    </div>
    <div v-else>
      <mswipe></mswipe>
    </div>
  </div>
</template>
<script>
import mswipe from "@mswipeH5/mainSwipe.vue";
import h5Nav from "@/component/h5nav/komoe";
export default {
  name: "home-h5",
  data() {
    return {
      bannerLists: [],
    };
  },
  created() {
    if(this.$region !== 'jp'){
      this.handleBanner();
    }
  },
  components: {
    mswipe,
    h5Nav,
  },
  mounted() {},
  methods: {
    handleBanner() {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.home
        .getBanner()
        .then((res) => {
          if (res.data.code === 0) {
            this.$toast.clear();
            this.bannerLists = res.data.data.filter(item => item.mobile_image);
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.homeH5 {
  width: 100%;
  min-height: calc(100vh - 1.8rem);
  height: auto;
  background: #f2f2f2;
}
</style>
